import { API_URL } from "@/constants/envVariables";

import { handleApiResponse } from "@/api/handleApiResponse";

import { buildAuthHeaders, getAuthCredentials } from "@/helpers/authHeaders";

import { preparePostDisbursementData } from "./postDisbursement";

import { ApiDisbursement, Disbursement } from "@/types";

export const postDisbursementWithInstructions = async (
  token: string,
  disbursement: Disbursement,
  file: File,
): Promise<ApiDisbursement> => {
  const formData = new FormData();

  const data = preparePostDisbursementData(disbursement);
  formData.append("data", JSON.stringify(data));
  formData.append("file", file);

  const response = await fetch(`${API_URL}/disbursements`, {
    method: "POST",
    credentials: getAuthCredentials(),
    headers: {
      ...buildAuthHeaders(token),
    },
    body: formData,
  });

  return handleApiResponse(response);
};
